query TransferCycle($id: UUID!) {
  transferCycle(id: $id) {
    _exportFilename
    transferHeaders
    _companyId
    _createdByUserid
    transactionTransfers(orderBy: LINE_NUMBER_ASC) {
      nodes {
        transferValues
      }
    }
  }
}
